<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'returnVisit'
}
</script>

<style>

</style>
